export enum EquipmentType {
    Energy = 1,
    AdductionSanitation = 2
}
